/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Attachment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Attachment({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Attachments/Attachment"
  
}) {
let messageComposeAttachmentNameValueData = fromData.useDataValue({ viewPath,
context: 'message_compose_attachment',
path: 'name',
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 marginBottom={2}
 maxWidth={260}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="message_compose_attachment.name"
 text={messageComposeAttachmentNameValueData}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}